import { ElementType } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/ConfigurationStorage/ElementType';
import { DecisionsTypePickerSettings } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/DecisionsTypePickerSettings';
import {
  getDecisionsTypePickerSettings,
  getElementRegistrationPickerSettings,
  getEntityPickerSettingsForType,
} from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityPickerService';
import { folderTypeName } from './EpickUtils';

//TODO alex: renmae to EntityPickerSettings?
export class EpickSettings {
  static async getForType(typeName: string) {
    const settings = await getEntityPickerSettingsForType({
      typeName,
    });
    if (!settings) {
      throw new Error(`No picker settings fetched for type: ${typeName}`);
    }
    return settings;
  }

  static getForFolder() {
    return EpickSettings.getForType(folderTypeName);
  }

  static getForElementRegistration(
    elementTypes: ElementType[],
    subElementType?: string,
    includeEmptySubElementType?: boolean,
    behaviorTypeName?: string
  ) {
    const settings = getElementRegistrationPickerSettings({
      elementTypes,
      subElementType,
      includeEmptySubElementType: includeEmptySubElementType ?? false,
      behaviorTypeName,
    });

    if (!settings) {
      throw new Error('No element registration settings fetched');
    }
    return settings;
  }

  static async getForDecisionsTypes(filterNames?: string[]): Promise<DecisionsTypePickerSettings> {
    const typeSettings = await getDecisionsTypePickerSettings({
      filterNames,
    });
    return typeSettings;
  }
}
